import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopBar } from "@/components/layout/TopBar";
import { BottomNav } from "@/components/layout/MobileNav";
import { CommandPalette } from "@/components/CommandPalette";
import { LeadFormDialog } from "@/components/LeadFormDialog";

export function AppLayout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      <Sidebar />
      <div className="md:pl-64">
        <TopBar onOpenSearch={() => setSearchOpen(true)} onNewLead={() => setLeadOpen(true)} />
        <main className="mx-auto max-w-[1400px] px-4 py-6 pb-24 md:px-8 md:pb-8">
          <Outlet />
        </main>
      </div>
      <BottomNav />
      <CommandPalette open={searchOpen} setOpen={setSearchOpen} />
      <LeadFormDialog open={leadOpen} onOpenChange={setLeadOpen} onSaved={() => navigate("/leads", { state: { refresh: Date.now() } })} />
    </div>
  );
}
